module.exports = __webpack_public_path__ + "static/media/LIFT.2d5a62b8.png";